<template>
    <b-navbar class="navigation" toggleable="md" type="dark" variant="dark" fixed="top" sticky>
        <b-navbar-toggle target="nav-collapse" />

        <b-navbar-brand href="/">
            <span style="line-height: 36px; margin-right: 12px;">LuPS</span>
            <img src="@/../assets/lupus-logo.png" height="36px" alt="Lupus Logo" />
        </b-navbar-brand>

        <b-collapse id="nav-collapse" is-nav>
            <b-nav-form v-if="currentPage === 'Home'" class="lupus-nav-set-view">
                <select
                    v-if="isConsolidateModus"
                    v-model="pharmacyGroupSelection"
                    class="form-control"
                >
                    <option v-for="(option, index) in pharmacyGroups" :key="index" :value="option">
                        {{ option.name }}
                    </option>
                </select>
                <select v-else v-model="pharmacySelection" class="form-control">
                    <option v-for="(option, index) in pharmacies" :key="index" :value="option">
                        {{ option.name }}
                    </option>
                </select>
                <select
                    :key="'year_' + yearSelection + pharmacySelection"
                    v-model="yearSelection"
                    class="form-control"
                >
                    <option
                        v-for="(option, index) in year"
                        :key="index"
                        :value="option"
                        :selected="index === 0"
                    >
                        {{ option }}
                    </option>
                </select>
                <select
                    :key="'month_' + yearSelection + pharmacySelection"
                    v-model="monthSelection"
                    class="form-control"
                >
                    <option
                        v-for="(option, index) in month"
                        :key="'month_' + index"
                        :value="option"
                        :selected="index === 0"
                    >
                        {{ option }}
                    </option>
                </select>

                <b-button variant="primary" class="form-control" @click="updateView">
                    Anzeigen
                </b-button>
                <b-form-checkbox
                    v-model="isConsolidateModus"
                    name="checkbox-1"
                    :value="true"
                    :unchecked-value="false"
                    switch
                >
                    <span class="text-light">Konsolidierungsmodus</span>
                </b-form-checkbox>
            </b-nav-form>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-form v-if="currentPage === 'Home'">
                    <b-button v-if="!isPaedActive" variant="success" @click="selectPaed()">
                        Preisänderungsdienst
                    </b-button>
                    <b-button v-else variant="danger" @click="stopPaed()">
                        Preisänderungsdienst beenden
                    </b-button>
                </b-nav-form>

                <b-nav-item-dropdown right>
                    <template slot="button-content">
                        Menü
                    </template>
                    <b-dropdown-item to="/" :active="currentPage === 'Home'">
                        Home
                    </b-dropdown-item>
                    <b-dropdown-item to="/export" :active="currentPage === 'Export'">
                        Exporthistorie
                    </b-dropdown-item>
                    <b-dropdown-item to="/blacklist" :active="currentPage === 'Blacklist'">
                        Ausgeblendete Artikel
                    </b-dropdown-item>
                    <b-dropdown-item to="/tabconfig" :active="currentPage === 'Tabs'">
                        Kartenreiter
                    </b-dropdown-item>
                    <b-dropdown-item to="/groups" :active="currentPage === 'Groups'">
                        Apothekengruppen
                    </b-dropdown-item>
                    <b-dropdown-item to="/label" :active="currentPage === 'Label'">
                        Elektronische Etiketten
                    </b-dropdown-item>
                    <b-dropdown-item to="/controlling" :active="currentPage === 'Controlling'">
                        Controlling
                    </b-dropdown-item>

                    <b-dropdown-item v-if="isAdmin" to="/admin" :active="currentPage === 'Admin'">
                        Administration
                    </b-dropdown-item>
                    <!--
                    <b-dropdown-item to="/controlling">
                        Controlling Tool
                    </b-dropdown-item> -->
                </b-nav-item-dropdown>

                <b-nav-item-dropdown right>
                    <!-- Using button-content slot -->
                    <template slot="button-content">
                        <em>{{ username }}</em>
                    </template>
                    <b-dropdown-item to="/me">Profil</b-dropdown-item>
                    <b-dropdown-item @click="logout">
                        Abmelden
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { EventBus } from "@/utils/EventBus.js";
import Data from "@/store/api/data/Data";

export default {
    name: "Navigation",
    data: function() {
        return {
            availableCombinations: []
        };
    },
    computed: {
        pharmacyGroups() {
            return this.$store.state.data.pharmacyGroup;
        },
        pharmacies() {
            return this.$store.state.data.pharmacies;
        },
        selectedPharmacies() {
            let pharmacyGroupSelection = null;
            let pharmacySelection = null;

            if (this.pharmacyGroupSelection && this.pharmacyGroupSelection.id) {
                pharmacyGroupSelection = this.pharmacies
                    .filter(pharmacy => pharmacy.pharmacyGroupId === this.pharmacyGroupSelection.id)
                    .map(pharmacy => pharmacy.id);
            }
            if (this.pharmacySelection && this.pharmacySelection.id) {
                pharmacySelection = [this.pharmacySelection.id];
            }

            return this.isConsolidateModus ? pharmacyGroupSelection : pharmacySelection;
        },
        year() {
            console.log("selectedPharmacies", this.selectedPharmacies);
            return Array.from(
                new Set(
                    this.availableCombinations
                        .filter(item => this.selectedPharmacies.includes(item.pharmacyId))
                        .map(item => item.year)
                )
            ).sort((a, b) => b - a);
        },
        month() {
            return Array.from(
                new Set(
                    this.availableCombinations
                        .filter(
                            item =>
                                this.selectedPharmacies.includes(item.pharmacyId) &&
                                this.yearSelection === item.year
                        )
                        .map(item => item.month)
                )
            ).sort((a, b) => b - a);
        },
        pharmacyGroupSelection: {
            get() {
                return this.$store.state.navSelection.pharmacyGroup;
            },
            set(value) {
                this.$store.commit("setSelectedPharmacyGroup", value);
            }
        },
        pharmacySelection: {
            get() {
                return this.$store.state.navSelection.pharmacy;
            },
            set(value) {
                this.$store.commit("setSelectedPharmacy", value);
            }
        },
        yearSelection: {
            get() {
                return this.$store.state.navSelection.year;
            },
            set(value) {
                this.$store.commit("setSelectedYear", value);
            }
        },
        monthSelection: {
            get() {
                return this.$store.state.navSelection.month;
            },
            set(value) {
                this.$store.commit("setSelectedMonth", value);
            }
        },
        isConsolidateModus: {
            get() {
                return this.$store.state.navSelection.isConsolidateModus;
            },
            set(value) {
                this.$store.commit("setConsolidateModus", value);
            }
        },
        username() {
            return this.$store.state.user.user_obj.username;
        },
        isPaedActive() {
            return this.$store.state.tabs.isPaedActive;
        },

        currentPage() {
            return this.$route.name;
        },
        isAdmin() {
            return this.$store.state.user.user_obj.role === "ADMIN";
        }
    },
    created() {
        // get API Date
        this.loadPharmacies();
        // default stage
        this.stopPaed();
        // load availability matrix
        Data.getAvailable().then(result => {
            this.availableCombinations = result.data;
            EventBus.$emit("navigation-ready");

            // init year/month to latest
            this.selectMonthYear();
        });
    },

    methods: {
        selectMonthYear: function() {
            this.yearSelection = this.year[0];
            this.monthSelection = this.month[0];
        },
        updateView: function() {
            this.$store.commit("resetPricingData");
            EventBus.$emit("navigation-change");
        },

        selectPaed() {
            this.$store.commit("setIsPaedActive", true);
            this.$store.dispatch("calculateAndFilterTabData");
        },
        stopPaed() {
            this.$store.commit("setIsPaedActive", false);
            this.$store.dispatch("calculateAndFilterTabData");
        },
        logout: function() {
            this.$store.dispatch("logout");
            this.$router.push("/login");
        },
        loadPharmacies: function() {
            this.$store
                .dispatch("loadPharmacies")
                .then(() => {
                    this.pharmacySelection.set(this.pharmacies[0]);
                })
                .catch(() => EventBus.$emit("getpharmacies-failed"));
        }
    }
};
</script>

<style scoped>
.lupus-nav-set-view > select,
.lupus-nav-set-view > button {
    margin: 8px;
}

.lupus-nav-set-view > button {
    flex: 1;
}
.form-control {
    margin-right: 8px;
}

.navigation {
    user-select: none;
}
</style>
